<section class="mx-auto w-full max-w-[1440px] p-6">
  <div class="grid gap-3 pb-4" id="charts-dashboard">
    <div class="flex justify-between">
      <h1 class="flex items-center gap-2">Operations Summary</h1>
      <button
        class="btn-secondary"
        (click)="downloadFilesAsPdf()"
        [disabled]="charts$._loadingCharts$() || isDownloading()"
      >
        <div
          class="custom-icon pdf"
          [ngClass]="{
            'opacity-20': charts$._loadingCharts$() || isDownloading(),
          }"
        ></div>
        @if (isDownloading()) {
          <mat-spinner diameter="16" />
        } @else {
          <span>Download</span>
        }
      </button>
    </div>

    <div class="kpi-flex flex flex-col md:flex-row">
      <div class="grid w-full gap-3 md:grid-cols-7">
        @if (charts$.mttrAllNOCCasesLife.signal(); as chart) {
          <app-gauge-value
            class="col-span-2 flex w-full"
            [ngClass]="chart.ngClass"
            [data]="chart.data"
            [loading]="chart.loading"
          ></app-gauge-value>
        }
        @if (charts$.yearNitelNps.signal(); as chart) {
          <app-gauge-value
            class="col-span-2 flex w-full"
            [ngClass]="chart.ngClass"
            [data]="chart.data"
            [loading]="chart.loading"
          ></app-gauge-value>
        }
        @if (charts$.csatSurveyResults.signal(); as chart) {
          <app-gauge-value
            class="col-span-2 flex w-full"
            [ngClass]="chart.ngClass"
            [data]="chart.data"
            [loading]="chart.loading"
          ></app-gauge-value>
        }
        <div class="col-span-1 flex flex-col gap-3">
          @if (charts$.activeServices.signal(); as chart) {
            <app-single-value
              class="flex w-full"
              [ngClass]="chart.ngClass"
              [data]="chart.data"
              [loading]="chart.loading"
            ></app-single-value>
          }
          @if (charts$.inflightOrders.signal(); as chart) {
            <app-single-value
              class="flex w-full"
              [ngClass]="chart.ngClass"
              [data]="chart.data"
              [loading]="chart.loading"
            ></app-single-value>
          }
        </div>
      </div>
    </div>

    <div class="grid w-full gap-3 md:grid-cols-6">
      @if (charts$.newClosedCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.closedCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.oldOpenCareCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.openCareCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.oldOpenNOCCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.openNOCCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.oldOpenSupportCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.openSuportCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.oldOpenFinanceCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.openFinanceCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.emergencyCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
      @if (charts$.openMaintenanceCases.signal(); as chart) {
        <app-single-value
          class="flex w-full"
          [ngClass]="chart.ngClass"
          [data]="chart.data"
          [loading]="chart.loading"
        ></app-single-value>
      }
    </div>

    <div class="charts grid w-full gap-3">
      @if (charts$.caseHistoryByDate.signal(); as chart) {
        <app-line-values
          [data]="chart.data"
          [loading]="chart.loading"
          (navigate)="handleNavigation($event)"
        ></app-line-values>
      }
    </div>

    <div
      class="charts horizontal-bars gap-3w-full grid [grid-template-columns:repeat(auto-fit,minmax(250px,1fr))] sm:[grid-template-columns:repeat(auto-fit,minmax(300px,1fr))]"
    >
      @if (charts$.ytdNocCasesClosedCode.signal(); as chart) {
        <app-horizontal-bars
          [data]="chart.data"
          [loading]="chart.loading"
          (navigate)="handleNavigation($event)"
        ></app-horizontal-bars>
      }
    </div>
    <div
      class="charts horizontal-bars grid w-full gap-3 [grid-template-columns:repeat(auto-fit,minmax(250px,1fr))] sm:[grid-template-columns:repeat(auto-fit,minmax(300px,1fr))]"
    >
      @if (charts$.mttrCircuitDown.signal(); as chart) {
        <app-vertical-bars
          [data]="chart.data"
          [loading]="chart.loading"
          (navigate)="handleNavigation($event)"
        ></app-vertical-bars>
      }
    </div>
  </div>
</section>
